/* eslint import/prefer-default-export: 0 */

import * as t from './action_types';

/**
 * @param {Object} params
 */
export const setMobileHeaderVisibility = params => ({
  type: t.MOBILE_HEADER_SET_VISIBILITY,
  payload: params,
});

export const setMobileMenuVisibility = params => ({
  type: t.MOBILE_MENU_SET_VISIBILITY,
  payload: params,
});

export const startMaintenanceMode = () => ({ type: t.START_MAINTENANCE_MODE });
export const finishMaintenanceMode = () => ({ type: t.FINISH_MAINTENANCE_MODE });

export const openAppFlyout = params => ({ type: t.OPEN_APP_FLYOUT, payload: params });
export const updateAppFlyout = params => ({ type: t.UPDATE_APP_FLYOUT, payload: params });
export const closeAppFlyout = () => ({ type: t.CLOSE_APP_FLYOUT, payload: {} });
export const appFlyoutIsOpened = () => ({ type: t.APP_FLYOUT_IS_OPENED });
export const appFlyoutisCloses = () => ({ type: t.APP_FLYOUT_IS_CLOSED });
